"use client";
import React, {JSX, useState} from 'react';
import {Benefit, BlockBase, ContentData} from '../../interfaces.ts';
import {getContentValue} from "../../utils.ts";
import {useServerProvider} from "../../use-server-provider.tsx";
interface BenefitsBlockProperties {
  withHeader: boolean;
  headerLevel: number;
  columns?: number;
  showDescription?: boolean;
}

interface BenefitsBlockContentData {
  content: string;
  headerText: string;
}

const BenefitsBlock: React.FC<{ block: BlockBase<BenefitsBlockProperties, BenefitsBlockContentData>, contentData?: ContentData<BenefitsBlockContentData> | null, benefits: Benefit[], editable?: boolean, locale: string, fallbackLocale: string }> = ({ block, benefits = [], contentData, editable, locale, fallbackLocale }) => {
  const { id, properties } = block;
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const onContentChange = useServerProvider<(blockId: string, field: string, value: any) => void>('onContentChange')

  const handleToggle = (index: number) => {
    if (block.properties.showDescription) {
      setExpandedIndex(expandedIndex === index ? null : index);
    }
  };

  const { headerText } = getContentValue(locale, fallbackLocale, block, contentData)

  const handleInput = (event: React.FormEvent) => {
    if (onContentChange) {
      onContentChange.value(id, 'headerText', (event.currentTarget as HTMLElement).innerHTML);
    }
  };

  const TagName = `h${properties.headerLevel}` as keyof JSX.IntrinsicElements;
  const headerBlock = <TagName className={`${id}-header`} key={id} onInput={handleInput} contentEditable={editable} suppressContentEditableWarning={true} data-block-id={id} data-field="headerText">{headerText}</TagName>;

  if (benefits.length === 0) {
    return (<></>)
  }

  return (
    <div className={`${id} benefit-list-container`} data-block={id}>
      {properties.withHeader && headerBlock}
      <div className={`${id}-benefit-list benefit-list`} data-has-descriptions={!!properties.showDescription}>
        {benefits.map((benefit, index) => (
          <div key={index} className="benefit-item" data-open={expandedIndex === index}>
            <div className="benefit-header" onClick={() => handleToggle(index)}>
              <img src={benefit.iconUrl} alt={benefit.label} className="benefit-icon" />
              <div className="benefit-label">{benefit.label}</div>
            </div>
            {block.properties.showDescription && expandedIndex === index && (
              <div className="benefit-description">{benefit.description}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BenefitsBlock;
